import React,{useState, useEffect, useRef}  from 'react';
import {useHistory,useParams} from 'react-router-dom'
import {Segment,Header,Icon,Container,  Button}  from 'semantic-ui-react'
import {recreateDB} from '../dexie/db'
import RegisterScan from './RegisterScan'


const Maintenance=({db,syncStatusChanged})=>
{
    const history=useHistory()
    const resync=()=>
    {
        if(window.confirm("Wirklich die lokale Datenbank auf dem Gerät zurücksetzen? Dabei gehen alle Änderungen, bzw. Pakete seid der letzten Synchronisierung verloren!"))
        {
           const auth=localStorage.getItem('auth')  
           recreateDB(db,syncStatusChanged,auth)
        }
    }

    return(
        <Container>
           <Segment>
                <Header as ="h3">Handy Registrieren</Header>
                <p>
                    bitt auch sicherstellen, dass unter dem folgen Link  die 
                    <a href='chrome://flags/#enable-experimental-web-platform-features'>experimental-web-platform-features</a>
                    auf 'enabled' stehen
                </p>
                <Button content="Handy neu registrieren" color='green' onClick={e=>history.push('/RegisterScan')}/>
            </Segment> 
            <Segment>
                <Header as ="h3">Handy neu mit der Datenbank synchronisieren</Header>
                <p>
                    Wenn die Synchronisation trotz Registrierung des Handys an der Theke nicht funktioniert,<br/>
                    kann man hier die lokale Datenbankversion löschen und eine aktuelle vom Server herunterladen
                </p>
                <Button content="Datenbank neu laden" color='red' onClick={resync}/>
            </Segment>
        </Container>
    )
}
export default Maintenance
